<template>
  <el-container>
    <el-header v-if="mainSystem" style="text-align: right;height: 84.5px;background: #fff;padding-left:0px;">
      <div style="position:absolute;">
        <!-- <a target="_blank" href="https://shop515726526.taobao.com/"> -->
        <a   href="javascript:void(0);">

        <!-- filter: grayscale(100%); -->
          <img style="height:84.5px;"  :src="$store.state.imgsrc2"   :style="{filter: gongjiri ? 'grayscale(100%)':''}"/>
        </a>
      </div>
      <div class="HeaderRight" style="position:absolute;height:84.5px;right:0px;background: #fff;">
        <div v-on:click="bigscreen1()">
          <Icon style="margin-left: 20px" :url="src[10]"></Icon>
        </div>
        <div v-on:click="bigscreen()">
          <Icon style="margin-left: 20px" :url="src[9]"></Icon>
        </div>
        <div v-on:click="Homepage()">
          <Icon style="margin-left: 6px" :url="src[0]"></Icon>
        </div>
        <div v-on:click="User()">
          <Icon :url="src[1]"></Icon>
        </div>
        <div v-on:click="Setting()">
          <Icon :url="src[2]"></Icon>
        </div>
        <div v-on:click="Login()">
          <Icon style="margin-left: 50px;" :url="src[3]" :style="{filter: gongjiri ? 'grayscale(100%)':''}"></Icon>
        </div>
      </div>
    </el-header>
    <el-header v-else style="text-align: right;height: 84.5px;background: rgb(220,220,220);padding-left:0px;">
      <div class="HeaderRight" style="position:absolute;height:84.5px;right:0px;background: rgb(220,220,220);">
        <div v-on:click="Homepage()">
          <Icon style="margin-left: 20px" :url="src[4]"></Icon>
        </div>
        <div v-on:click="User()">
          <Icon :url="src[5]"></Icon>
        </div>
        <div v-on:click="Setting()">
          <Icon :url="src[6]"></Icon>
        </div>
        <div v-on:click="Login()">
          <Icon style="margin-left: 50px;" :style="{filter: gongjiri ? 'grayscale(100%)':''}" :url="src[7]"></Icon>
        </div>
      </div>
    </el-header>
    <div class="zysz">
      <el-dialog  :title="$t('head.set')"  :visible.sync="dialogVisible" width="400px">
        <el-form :label-position="'left'" v-model="form" label-width="200px" width="300px">
          <el-form-item :label="$t('head.userpineng')" >
            <div class="kg1">
              <div class="kgon1">ON</div>
              <div class="kgoff1">OFF</div>
              <el-switch v-model="form.prjAuditAccess" :width="75" active-color="#131313" inactive-color="#A8A9AA">
              </el-switch>
            </div>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item :label="$t('head.usershenpineng')" >
            <div class="kg1">
              <div class="kgon1">ON</div>
              <div class="kgoff1">OFF</div>
              <el-switch v-model="form.userAuditAccess" :width="75" active-color="#131313" inactive-color="#A8A9AA">
                ></el-switch>
            </div>
          </el-form-item>
          <el-divider></el-divider>
          <!-- <el-form-item label="默认使用工程管理功能">
            <div class="kg1">
              <div class="kgon1">ON</div>
              <div class="kgoff1">OFF</div>
              <el-switch v-model="form.userManageAccess" :width="75" active-color="#131313" inactive-color="#A8A9AA">
                ></el-switch>
            </div>
          </el-form-item> -->
          <div style="clear: both;"></div>
          <div style="text-align: center;overflow: auto">
            <el-button @click="qr()" class="qran" type="success">{{$t('common.Confirm')}}</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
    <NavMenu></NavMenu>
    <Main></Main>
  </el-container>
</template>

<script>
import Icon from "./Icon"
import Main from '../Layout/Main'
import { EventBus} from '../Layout/bus'
import NavMenu from './NavMenu/NavMenu'
import { mapGetters } from 'vuex'
import { removeToken, getToken } from '@/utils/token'
import { removeToken1, getToken1 } from '@/utils/token1'
import Cookies from 'js-cookie'

export default {
  name: 'Header',
  components: {
    Icon,
    Main,
    NavMenu
  },
  computed: {
    ...mapGetters([
      'mainSystem',
    ])
  },
  data() {
    return {
      src: [require("@/assets/homepage.png"),
      require("@/assets/user.png"),
      require("@/assets/setting.png"),
      require("@/assets/quit.png"),
      require("@/assets/homepage1.png"),
      require("@/assets/user1.png"),
      require("@/assets/setting1.png"),
      require("@/assets/quit.png"),
      require("@/assets/databigscreen.png"),
      require("@/assets/daping.png"),
      require("@/assets/shuaxin1.png")
      ],
      gongjiri: false,
      form: {
        prjAuditAccess: true,
        userAuditAccess: true,
        userManageAccess: true
      },
      dialogVisible: false
    }
  },
  methods: {
    Login() {
      // console.log(getToken())
      this.$api.get('/logout', {}).then(r => {
        // console.log(Cookies.keys())
        removeToken()
        removeToken1()


        // Cookies.set('ASP.NET_SessionId', '')
        this.$cookies.remove('ASP.NET_SessionId')
        localStorage.removeItem('VIP')
        // this.$router.push('/Login?redirect=' + encodeURIComponent(this.$route.fullPath))
        // window.location.href = '/'
        this.$router.push({path: 'Login',name:'登录'})
      })
    },
    Homepage() {
      this.$router.push({ path: 'ChildPrj', name: '工程首页' })
    },
    User() {
      this.$router.push({ path: 'User', name: '用户' })
    },
    bigscreen(){
      this.$router.push('/bigscreen')
    },
    Setting() {
      this.dialogVisible = !this.dialogVisible
      var v = this
      this.$api.post('/user/sysSetting', { flag: 'get' }).then(r => {
        this.form.prjAuditAccess = r.data.prjAuditAccess === "0" ? false : true,
          this.form.userAuditAccess = r.data.userAuditAccess === "0" ? false : true,
          this.form.userManageAccess = r.data.userManageAccess === "0" ? false : true
      })
    },
    qr() {
      var p = {
        flag: 'update',
        data: {
          prjAuditAccess: this.form.prjAuditAccess === false ? "0" : "1",
          userAuditAccess: this.form.userAuditAccess === false ? "0" : "1",
          userManageAccess: this.form.userManageAccess === false ? "0" : "1"
        }
      }
      p.data = JSON.stringify(p.data)
      this.$api.post('/user/sysSetting', p).then(r => {
        this.dialogVisible = !this.dialogVisible
      })
    },
    DateFormat() {
      let date = new Date(),
        currentDate,
        currentTime,
        seperator = "-", // 如果想要其他格式 只需 修改这里
        month = date.getMonth() + 1,
        day = date.getDate(),
        hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
        minute =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
        second =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      month >= 1 && month <= 9 ? (month = "0" + month) : "";
      day >= 0 && day <= 9 ? (day = "0" + day) : "";
      //当前 日期
      currentDate = month + seperator + day;
      //当前 时间
      currentTime = hour + ":" + minute + ":" + second;
      // 输出格式 为 8-27 14:45:33
      return currentDate + " " + currentTime;
    },
    currenttime() {

      var nowTime = this.DateFormat();
      // 2.设置南京事件公祭日
      var NJ_country_startTime = "12-13 00:00:00";
      var NJ_country_overTime = "12-14 00:00:00";
      //2.设置汶川哀悼开始及结束 是 5月12号凌晨
      var earthquake_startTime = "05-12 00:00:00";
      var earthquake_overTime = "05-12 00:00:00";
      //3.设置汶川哀悼开始及结束 是 5月12号凌晨
      var earthquake1_startTime = "12-13 00:00:00";
      var earthquake1_overTime = "12-14 00:00:00";
      //在这判断时间，时间字符串可以直接判断大小，不过要精确到秒
      if (nowTime >= NJ_country_startTime && nowTime <= NJ_country_overTime) {
        // 4.把html 设置灰色滤镜
        // grey();
        this.gongjiri = true

      } else if (nowTime >= earthquake_startTime && nowTime <= earthquake_overTime) {
        // 4.把html 设置灰色滤镜
        // grey();
        this.gongjiri = true
      } else if (nowTime >= earthquake1_startTime && nowTime <= earthquake1_overTime) {
        // 4.把html 设置灰色滤镜
        // grey();
        this.gongjiri = true
      }

    },
    bigscreen1(){
     EventBus.$emit('my-event2')
    }
  },
  created(){

     this.currenttime()
  }
}
</script>

<style scoped>
.kg1 {
  position: relative;
}
.kgon1 {
  color: white;
  position: absolute;
  font-size: 12px;
  z-index: 2;
  top: 22px;
  left: 55px;
  font-weight: 500;
}
.kgoff1 {
  transform: rotateY(0deg);
  color: white;
  position: absolute;
  font-size: 12px;
  z-index: 2;
  top: 22px;
  left: 92px;
  font-weight: 500;
}
.qran {
  width: 142px;
  height: 36px;
  line-height: 8px;
}
.HeaderRight {
  height: 100%;
  justify-content: flex-end;
  display: flex;
  align-items: center; /*垂直居中*/
  background: rgb(222, 222, 222);
  padding-top: 16px;
}
>>> .el-button {
  border-radius: unset !important;
}
>>> .el-button--success {
  background-color: #212f44 !important;
  border-color: #212f44 !important;
}
>>> .el-button--success:hover {
  background-color: #212f44 !important;
  border-color: #212f44 !important;
}
</style>
<style>
.zysz .el-dialog__body {
  padding: 42px 36px;
}
.zysz .el-dialog__header {
  padding: 20px 28px 10px;
}
.zysz .el-form-item__label {
  margin-top: 2px;
  font-size: 15px;
}
.zysz .el-switch {
  margin-left: 46px;
}
.zysz .el-button {
  margin-top: 50px;
}
.zysz .el-switch__core {
  height: 26px;

  border-radius: 6px;
}
.zysz .el-switch__core:after {
  border-radius: 6px;
  height: 26px;
  width: 34px;
  left: -1px;
  top: -2px;
  border: 1px solid gainsboro;
  background: -webkit-linear-gradient(white, gainsboro);
  z-index: 4;
}
.zysz .el-switch.is-checked .el-switch__core::after {
  margin-left: -35px;
}
.zysz .el-switch {
  margin-top: 12px;
}

.zysz .el-form-item__content {
  line-height: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Header.vue